import { createSlice } from "@reduxjs/toolkit";
import Cookies from "js-cookie";

const initialState = {
  token: null,
  user: null,
  isLoggedIn: false,
  isLoading: false,
  error: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginSuccess: (state, action) => {
      const { token, user } = action.payload;
      state.token = token;
      state.user = user;
      state.isLoggedIn = true;
      // AUTH-37 / SEC-12: both cookies end with the token (1 day), never go cross-site, and are HTTPS-only
      // when the app is served over HTTPS
      const cookieFlags = { expires: 1, sameSite: "Strict", secure: window.location.protocol === "https:" };
      Cookies.set("token", state.token, cookieFlags);
      Cookies.set("user", JSON.stringify(state.user), cookieFlags);
    },
    logoutSuccess: (state) => {
      Cookies.remove("token");
      Cookies.remove("user");
      const newState = {
        ...initialState,
        isLoading: false,
        error: null,
      };

      return newState;
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
  },
});

// Action creators
export const { loginSuccess, logoutSuccess, setLoading, setError } =
  authSlice.actions;

// Reducer
export default authSlice.reducer;
